import { IAddNotePayload } from "models/notes";
import { useCentralApi, useCurrentUser } from "hooks/shared";

type IGetResourcesByResponsibilityPayload = {
    workspaceId: number,
    responsibilityId: number,
    workItemId: number,
    draft?: boolean
}

type Resource = {
    responsibilityId: number;
    resourceId: string;
    resourceName: string;
    displayName: string;
    draft?: boolean;
};

type ApiResponse = {
    resources: Resource[];
    total: number;
};

const useWorkItemGetResourcesByResponsibility = () => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const handleGetResourcesByResponsibility = async (payload: IGetResourcesByResponsibilityPayload): Promise<Resource[]> => {

        var query = new URLSearchParams;
        query.append(payload.draft ? 'draftId':'workItemId', String(payload.workItemId))
        const result = await fetcher(
            payload.draft ? `/api/v3/drafts/workitems/${payload.workspaceId}/resource-allocation/${payload.responsibilityId}?${query}` :
                            `/api/v3/workitems/${payload.workspaceId}/resource-allocation/${payload.responsibilityId}?${query}`,
            {
                method: "GET",
            }
        );

        const data: ApiResponse = await result.json();
        return data.resources;
    };

    return handleGetResourcesByResponsibility; // Return the async function directly
};

export default useWorkItemGetResourcesByResponsibility;
